import { addresses as addressesApi } from '@afosto/contacts/api/Addresses';

export default async method => {
  try {
    if (method?.method?.is_carrier_location && method?.servicePoint?.address) {
      const addressResponse = await addressesApi.createAddress(method?.servicePoint?.address);
      const { data = {} } = addressResponse;
      return data?.id;
    }

    return null;
  } catch (error) {
    return null;
  }
};
